// @flow

const FILTER_BAR_HEIGHT = 38;
export const MEMBER_HEADER_HEIGHT = 140;

const memberHeaderStyles = {
  topHeaderContainer: (theme) => ({
    width: '100%'
  }),

  grow: (theme) => ({
    flexGrow: 1
  }),

  row: (theme) => ({
    ...theme.mixins.toolbar
  }),

  rowSub: (theme) => ({
    ...theme.mixins.toolbar,
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    height: theme.layout.customProps.toolbar.height,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  }),

  rowSubContainer: (theme) => ({
    flexShrink: 0,
    flexWrap: 'nowrap',
    width: 'auto',
    alignItems: 'center'
  }),

  rowSubTypoCtr: (theme) => ({
    alignItems: 'center'
  }),

  subHeaderCaption: (theme) => ({
    fontSize: '1.1rem'
  }),

  pageTitle: (theme) => ({
    marginRight: theme.spacing(4),
    color: 'white',
    textShadow: '0px 0 4px hsl(0deg 0% 0% / 12%)',
    '& a': {
      textDecoration: 'none',
      color: 'inherit'
    },
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'nowrap',
      overflowX: 'scroll',
      maxWidth: '40vw'
    }
  }),
  menuButton: (theme) => ({
    color: 'white',
    textShadow: '0px 0 4px hsl(0deg 0% 0% / 12%)',
    width: '1.2rem',
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    height: 50,
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  }),

  appBar: (theme) => ({
    boxShadow: 'none',
    marginLeft: theme.layout.customProps.drawer.width,
    zIndex: theme.zIndex.drawer + 1,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${theme.layout.customProps.drawer.width}px)`
    }
    // Sibling margin removed - ContentContainer now handles mobile spacing
  }),

  appBarFullscreen: (theme) => ({
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% + 1px)'
    }
  }),

  toolbarRoot: (theme) => ({
    paddingLeft: 0,
    paddingRight: 0
  }),
  toolbar: (theme) => ({
    paddingLeft: 0,
    paddingRight: 0,
    minHeight: theme.layout.customProps.toolbar.height || 56,
    display: 'flex',
    flexDirection: 'column'
  }),

  topBar: (theme) => ({
    background: theme.palette.primary.light,
    color: theme.palette.primary.light,
    paddingRight: 0,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: 0,
      width: '100%'
    }
  }),

  bottomBar: (theme) => ({
    background: theme.palette.primary.lighter,
    color: theme.palette.primary.light,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    [theme.breakpoints.down('xs')]: {
      marginLeft: -theme.spacing(1),
      width: `calc(100% + ${theme.spacing(1)}px)`
    }
  }),

  bottomBarContainer: (theme) => ({
    flexWrap: 'nowrap',
    display: 'flex',
    overflowX: 'auto'
  }),

  filterContainer: (theme) => ({
    display: 'flex',
    borderRadius: 24,
    background: 'white',
    height: FILTER_BAR_HEIGHT
  }),

  filterBox: (theme, position: "first" | "last") => ({
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      ...(position === 'first' && {
        marginLeft: 0
      }),
      ...(position === 'last' && {
        borderRight: 0
      })
    }
  }),

  searchBox: (theme) => ({
    border: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 160,
      '&.first': {
        marginLeft: 0
      }
    }
  }),

  customersSearchBox: (theme) => ({
    border: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 150,
      '&.first': {
        marginLeft: 0
      }
    }
  }),

  toggleContainer: (theme) => ({
    height: theme.layout.customProps.toolbar.height,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: 0,
    background: 'transparent',
    '& *': {
      display: 'flex',
      flexDirection: 'column',
      color: 'white',
      fontSize: '0.9rem',
      textDecoration: 'none'
    },
    '& i': {
      height: 28,
      fontSize: '1.6rem',
      filter: 'drop-shadow( 2px 1px 2px rgba(0, 0, 0, .1))'
    },
    '& svg': {
      height: 28,
      fontSize: '1.8rem',
      filter: 'drop-shadow( 2px 1px 2px rgba(0, 0, 0, .1))'
    }
  }),

  buttonGroup: (theme) => ({
    background: 'white',
    boxShadow: 'none',
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${
      theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'
    }`
  }),

  button: (theme) => ({
    color: 'rgba(0, 0, 0, 0.65)',
    height: 36,
    padding: '6px 12px',
    borderTopWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderRadius: 0,
    '&:first-of-type': {
      marginLeft: 0,
      borderRightWidth: 1
    }
  }),

  dividerRight: (theme) => ({
    marginRight: theme.spacing(8)
  }),

  navButton: (theme) => ({
    height: theme.layout.customProps.toolbar.height,
    minWidth: theme.layout.customProps.toolbar.height,
    textTransform: 'none',
    textShadow: '0px 0 4px hsl(0deg 0% 0% / 12%)',
    padding: `10px ${theme.spacing(1)} 0 ${theme.spacing(1)}`,
    borderRadius: 0,
    color: 'white',
    '& *': {
      whiteSpace: 'nowrap'
    }
  }),

  buttonIconText: (theme) => ({
    marginLeft: theme.spacing(1)
  }),

  userProfileSubMenuCtr: (theme) => ({
    height: '100%',
    minWidth: 120,
    right: 0,
    '& a': {
      textDecoration: 'none'
    },
    '& *': {
      color: 'white'
    },
    '&.light *': {
      color: theme.palette.primary.main
    }
  }),

  listItem: (theme) => ({
    paddingTop: 0,
    paddingBottom: 0,
    minHeight: theme.layout.customProps.toolbar.height,
    textAlign: 'right',
    '& p': {
      fontSize: '0.8rem'
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      minWidth: 44 // Ensure adequate touch target
    }
  }),

  subListItem: (theme) => ({
    paddingTop: 0,
    paddingBottom: 0,
    minHeight: theme.layout.customProps.toolbar.height,
    textAlign: 'left',
    '& p': {
      fontSize: '0.8rem'
    }
  }),

  switchActHeader: (theme) => ({
    height: theme.layout.customProps.header.height,
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.light,
    color: `${theme.palette.primary.dark} !important`,
    fontWeight: 'bold',
  }),

  userProfileSubMenuCollapse: (theme) => ({
    position: 'absolute',
    backgroundColor: theme.palette.primary.light,
    zIndex: 2,
    width: '100%',
    '&.light': {
      backgroundColor: theme.palette.background.default
    }
  }),

  userFullName: (theme) => ({
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1)
  }),

  userIcon: (theme) => ({
    marginLeft: theme.spacing(1),
    marginRight: 0
  }),

  itemTextCtr: (theme) => ({
    padding: '0 0',
    minWidth: 40
  }),

  menuRoot: (theme) => ({
    borderRadius: 0,
    backgroundColor: theme.palette.background.default,
    width: `${theme.layout.customProps.drawer.width * 2}px`,
    top: `${theme.layout.customProps.toolbar.height * 2}px !important`
  }),

  subMenuListRoot: (theme) => ({
    height: 'auto',
    paddingTop: 0,
    paddingBottom: 0
  }),

  menuListItem: (theme) => ({
    maxHeight: theme.layout.customProps.toolbar.height,
    padding: 20,
    '&:hover': {
      cursor: 'pointer'
    },
    display: 'block'
  }),

  iconRoot: (theme) => ({
    minWidth: 0,
    marginLeft: theme.spacing(1)
  })
};

export default memberHeaderStyles;